


// ------------------------Second Trail -----------------------------------------







import React from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { loginSelector } from '../../api/authSlice';

export default function RegisterUser() {
    const { curr_user } = useSelector(loginSelector);
    const { id } = useParams();

    const array = curr_user?.orders?.concat(curr_user?.productorders) || [];

    return (
        <div className="container mb-5 my-5 w-full mx-1 md:mx-40" style={{ minHeight: "63vh" }}>
            <h2 className="text-center font-bold text-2xl mb-6 text-gray-800">Orders</h2>

            {array.map((item, k) => (
                <div
                    key={k}
                    className="order-card mb-6 p-6 rounded-lg shadow-lg bg-white"
                    style={{ border: "1px solid #f0f0f0", transition: 'transform 0.3s' }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1.0)'}
                >
                    {/* Order Summary Section */}
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 border-b pb-4 border-gray-200">
                        <div>
                            <p className="text-lg font-semibold text-gray-700 mb-2">Order ID: <span className="font-normal">{item.sycOrderId}</span></p>
                            <p className="text-sm text-gray-500">Date: {moment(item.createdAt).format('DD/MM/YYYY')}</p>
                        </div>
                        <div className="mt-3 md:mt-0">
                            <p className="text-lg font-semibold text-gray-700">Total Amount: <span className="text-green-600">&#8377;{item.total}</span></p>
                        </div>
                    </div>

                    {/* Address Section */}
                    <div className="mb-4 text-gray-600">
                        <p><strong>Delivery Address:</strong> {item.address}</p>
                    </div>

                    {/* Order Items Section */}
                    <div>
                        <div className="grid grid-cols-4 text-center font-semibold border-b pb-2 border-gray-300 text-gray-600">
                            <div>Item</div>
                            <div>Unit Price</div>
                            <div>Quantity</div>
                            <div>Sub Total</div>
                        </div>

                        {(item.scouponsOrder || item.products)?.map((product, i) => (
                            <div
                                key={i}
                                className="grid grid-cols-4 text-center py-3 border-b border-gray-100 text-gray-700 hover:bg-gray-50"
                            >
                                <div>{product.name}</div>
                                <div>&#8377;{product.value}</div>
                                <div>{product.quantity || product.qty}</div>
                                <div>&#8377;{(product.quantity || product.qty) * product.value}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
